import { msg } from "@lingui/core/macro";
import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { AuthPlaceholder } from "@/components/auth-placeholder";
import { PageContainer } from "@fleet/ui/page-container";
import { NetworkPage } from "@/features/domain/components/network-page";
import { useI18n } from "@/providers/i18n-provider";

function NetworkRoutePage() {
  const { t } = useI18n();
  return (
    <AuthPlaceholder
      title={t(msg`Network`)}
      description={t(
        msg`Sign in to manage your network of churches and see the aggregated roll-up.`,
      )}
    >
      <PageContainer maxWidth="3xl">
        <NetworkPage />
      </PageContainer>
    </AuthPlaceholder>
  );
}

export const networkRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/network",
  component: NetworkRoutePage,
});
